// extracted by mini-css-extract-plugin
export default {"casino-tabs":"casino-tabs_casino-tabs__Zgacw"};